import React from 'react'
import PropTypes from 'prop-types'
import { Button } from '../../../../dbWebUI'
import { Icon, Box, Text } from '@deseretbook/react-ui'
import {
  ANNOTATION_NOTE_ACTION,
  ANNOTATION_HIGHLIGHT_ACTION,
  ANNOTATION_DELETE_ACTION,
  ANNOTATION_BOOKMARK_ACTION,
} from '../../../../utils/constants'
import CopyTooltip from '../../../tooltips/CopyTooltip'

/**
 * Default `AnnotationActionMenu` view for displaying all the available options
 * related to the selected annotation. It should be used as a child of
 * `AnnotationActionMenu`.
 *
 * @param {object} props - component props
 * @returns {function} Component
 */
function DefaultView({
  activeAction,
  canDelete,
  hasHighlight,
  changeView,
  createHighlight,
  deleteAnnotation,
  selectedText,
  hasBookmark,
}) {
  return (
    <Box style={{ padding: '20px', width: '250px' }}>
      <Box
        alignItems="center"
        justifyContent="space-between"
        style={{
          marginBottom: '20px',
        }}
      >
        {/** Create/Edit Highlight Button. */}
        <Button
          className="default-view-button"
          isWhite
          hasLabeledIcon
          isLoading={activeAction === ANNOTATION_HIGHLIGHT_ACTION}
          onClick={hasHighlight ? () => changeView(ANNOTATION_HIGHLIGHT_ACTION) : createHighlight}
          style={{ marginLeft: 0 }}
          disabled={hasBookmark}
        >
          {hasHighlight ? (
            <Icon className="default-view-icon" name="colorWheel" style={{ opacity: 1 }} />
          ) : (
            <Icon className="default-view-icon" name="highlight" />
          )}
          <Text className="default-view-header">{hasHighlight ? 'Style' : 'Highlight'}</Text>
        </Button>

        {/** Edit Note Button */}
        <Button
          className="default-view-button"
          isWhite
          hasLabeledIcon
          isLoading={activeAction === ANNOTATION_NOTE_ACTION}
          onClick={() => changeView(ANNOTATION_NOTE_ACTION)}
        >
          <Icon className="default-view-icon" name="noteEdit" />
          <Text className="default-view-header">Note</Text>
        </Button>

        {/** Bookmark Button */}
        <Button
          className="default-view-button"
          isWhite
          hasLabeledIcon
          isLoading={activeAction === ANNOTATION_BOOKMARK_ACTION}
          onClick={() => changeView(ANNOTATION_BOOKMARK_ACTION)}
        >
          <Icon className="default-view-icon" name="bookmark" />
          <Text className="default-view-header">Bookmark</Text>
        </Button>

        {/** Tag Button */}
        {/* <Button
          className="default-view-button"
          isWhite
          hasLabeledIcon
          disabled
          isLoading={activeAction === ANNOTATION_BOOKMARK_ACTION}
          onClick={() => changeView(ANNOTATION_BOOKMARK_ACTION)}
        >
          <Icon className="default-view-icon" name="tag" />
          <Text className="default-view-header">Tag</Text>
        </Button> */}

        {/** Define Button */}
        {/* <Button
          className="default-view-button"
          isWhite
          hasLabeledIcon
          isLoading={activeAction === ANNOTATION_BOOKMARK_ACTION}
          onClick={() => changeView(ANNOTATION_BOOKMARK_ACTION)}
          disabled
        >
          <Icon className="default-view-icon" name="define" />
          <Text className="default-view-header">Define</Text>
        </Button> */}
      </Box>
      <Box alignItems="center" justifyContent="space-between">
        {/** Copy Button */}
        <CopyTooltip textToCopy={selectedText}>
          <Button className="default-view-button" isWhite hasLabeledIcon style={{ marginLeft: 0 }}>
            <Icon className="default-view-icon" name="copy" />
            <Text className="default-view-header">Copy</Text>
          </Button>
        </CopyTooltip>

        {/** Share Button */}
        <CopyTooltip textToCopy={window.location.href}>
          <Button className="default-view-button" isWhite hasLabeledIcon>
            <Icon className="default-view-icon" name="share" />
            <Text className="default-view-header">Share</Text>
          </Button>
        </CopyTooltip>

        {/* <Box style={{ width: '10rem', height: '2rem' }} /> */}

        {/** Only display the edit button if the annotation exists. */}
        <Button
          className="default-view-button"
          isWhite
          isBorderless
          hasLabeledIcon
          isLoading={activeAction === ANNOTATION_DELETE_ACTION}
          onClick={deleteAnnotation}
          disabled={!canDelete}
        >
          <Icon className="default-view-icon" name="close" style={{ color: 'red' }} />
          <Text className="default-view-header">Remove</Text>
        </Button>
      </Box>
    </Box>
  )
}

DefaultView.defaultProps = {
  activeAction: null,
  canDelete: false,
  hasHighlight: false,
  hasNote: false,
  changeView: () => {},
  createHighlight: () => {},
  deleteAnnotation: () => {},
}

DefaultView.propTypes = {
  /** Which action is loading or being displayed. */
  activeAction: PropTypes.string,
  /** True if the annotation exists and is editable. */
  canDelete: PropTypes.bool,
  /** True if a highlight exists and is editable. */
  hasHighlight: PropTypes.bool,
  /** True if a note exists and is editable. */
  hasNote: PropTypes.bool,
  /** Callback for changing the `AnnotationActionMenu` view. */
  changeView: PropTypes.func,
  /** Callback for creating a new highlight. */
  createHighlight: PropTypes.func,
  /** Callback for deleting an existing annotation. */
  deleteAnnotation: PropTypes.func,
}

export default DefaultView
